import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { PageFooterComponent } from '../page-footer/page-footer.component';
import { NotesComponent } from '../notes/notes.component';
import { RoiCalculationComponent } from '../roi-calculation/roi-calculation.component';
import { SpacesService } from '../../services/spaces.service';
import { Space, RoiFields } from '../../models/space.model';

@Component({
  selector: 'app-value-analysis',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    PageHeaderComponent,
    PageFooterComponent,
    NotesComponent,
    RoiCalculationComponent
  ],
  templateUrl: './value-analysis.component.html',
  styleUrl: './value-analysis.component.scss'
})
export class ValueAnalysisComponent implements OnInit {
  @Input() showNotes = false;
  space: Space | null = null;

  constructor(
    private readonly spacesService: SpacesService
  ) {}

  ngOnInit(): void {
    this.spacesService.activeSpace$.subscribe((space) => {
      this.space = space;
    });
  }

  onRoiFieldChange<K extends keyof RoiFields>(field: K, value: RoiFields[K]): void {
    this.spacesService.updateActiveSpaceRoiField(field, value);
  }

}
